import React, { Component } from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary';
  children: React.ReactNode;
  icon?: boolean;
  href?: string;
}
export function Button({
  variant = 'primary',
  children,
  className = '',
  icon = false,
  href,
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center px-8 py-4 text-base font-medium transition-colors duration-200 rounded-full focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-neutral-900';
  const variants = {
    primary: 'bg-neutral-900 text-white hover:bg-neutral-800 border border-transparent',
    secondary: 'bg-transparent text-neutral-900 border border-neutral-200 hover:border-neutral-900 hover:bg-neutral-50'
  };
  const content = <>
      {children}
      {icon && <ArrowRight className="ml-2 h-4 w-4" data-id="element-81" />}
    </>;
  const Component = href ? motion.a : motion.button;
  return <Component href={href} className={`${baseStyles} ${variants[variant]} ${className}`} whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} {...props as any} data-id="element-82">
      {content}
    </Component>;
}